// src/pages/Payments/Payments.jsx
import React from "react";
import PaymentDashboard from "./PaymentDashboard";

const Payments = () => {
  return <PaymentDashboard />;
};

export default Payments;
